import { Navigate, Route, Routes } from "react-router-dom";
import AdminLayout from "./components/AdminLayout";
import ProtectedRoute from "./routes/ProtectedRoute";
import LoginPage from "./pages/Login";
import AcceptInvitePage from "./pages/AcceptInvite";
import TenantsPage from "./pages/Tenants";
import TenantDetailPage from "./pages/TenantDetail";
import MembersPage from "./pages/Members";
import SuppressionsPage from "./pages/Suppressions";

export default function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/tenants" replace />} />
        <Route path="tenants" element={<TenantsPage />} />
        <Route path="tenants/:id" element={<TenantDetailPage />} />
        <Route path="members" element={<MembersPage />} />
        <Route path="suppressions" element={<SuppressionsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
